import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierUnassignmentHistoryReport extends Layout {
    excludabletextbox1: ExcludableTextbox;
    excludabletextbox2: ExcludableTextbox;
    excludabletextbox3: ExcludableTextbox;
    excludabletextbox4: ExcludableTextbox;
    excludabletextboxR: ExcludableTextbox;
    sourceCarrierUnassignmentHistory: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxSortBy: Textbox;
}
